import { useEffect, useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import debounce from "lodash/debounce";
import { isDocumentsQuery } from "./useDocuments";

export function useRefreshDocuments(clientPortalGuid: string) {
    const queryClient = useQueryClient();

    const refreshDocuments = useMemo(
        () =>
            debounce(() => {
                void queryClient.invalidateQueries({ predicate: (query) => isDocumentsQuery(query, clientPortalGuid) });
            }, 400),
        [queryClient, clientPortalGuid]
    );

    useEffect(() => () => refreshDocuments.cancel(), [refreshDocuments]);

    return refreshDocuments;
}
